import ListPage, { useList } from '@/components/BaseList';
import { usePermission } from '@/common/hooks/index';
import { httpPageOdsNationalAreaCode } from '@/services/datamanagement';
import React from 'react';
import SearchForm from './components/SearchForm';
import styles from './index.less';

/**
 * 2018年行政区化码
 * @returns
 */
const AdministrativeCode: React.FC = () => {
  const { permission } = usePermission();

  const list = useList();
  const fetchAPi = (params: any) => {
    const req: any = {
      // ...params,
      limit: params.pageSize,
      pageNo: params.current,
      cond: {
        areaName: params.areaName,
        areaCode: params.areaCode,
      },
      // orders: [
      //   {
      //     direction: params.direction === 'ascend' ? 'ASC' : 'DESC',
      //     property: params.property || 'createTime',
      //   },
      // ],
    };

    return httpPageOdsNationalAreaCode(req).then((res) => {
      return {
        listData: res.data,
        pagination: {
          current: res.pageIndex,
          pageSize: res.pageSize,
          total: res.totalCount,
        },
      };
    });
  };

  const changetable = (pagination: any, filters: any, sorter: any) => {
    const property: string = sorter.columnKey;
    list.current.fetchListData({ direction: sorter.order, property });
  };

  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 200,
      children: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          width: 200,
        },
      ],
    },
    {
      title: '统计用区划代码',
      dataIndex: 'areaCode',
      key: 'areaCode',
      children: [
        {
          title: 'areaCode',
          dataIndex: 'areaCode',
          key: 'areaCode',
        },
      ],
    },
    {
      title: '名称',
      dataIndex: 'areaName',
      key: 'areaName',
      align: 'left',
      children: [
        {
          title: 'areaName',
          dataIndex: 'areaName',
          key: 'areaName',
        },
      ],
    },
  ];

  return (
    <div className={styles.disease}>
      <ListPage
        list={list}
        fetchApi={fetchAPi}
        columns={columns}
        SearchForm={permission.sysSearchBtn && SearchForm}
        BodyProps={{
          onChange: (pagination: any, filters: any, sorter: any) => {
            changetable(pagination, filters, sorter);
          },
        }}
      />
    </div>
  );
};

export default AdministrativeCode;
